/**
 * BucketRepository — reads and writes the buckets table. SQL only (rule R3).
 */

import type { SqliteClient } from '../adapters/sqlite-client';
import type { Bucket } from '../types';
import { toBucket } from './row-mapping';

/** Two buckets, keyboard 1 and 2. No "maybe" — it slows culling down. */
export const DEFAULT_BUCKETS: { name: string; kind: 'keep' | 'reject'; hotkey: string }[] = [
  { name: 'Keep', kind: 'keep', hotkey: '1' },
  { name: 'Reject', kind: 'reject', hotkey: '2' },
];

export class BucketRepository {
  constructor(private readonly db: SqliteClient) {}

  list(projectId: number): Bucket[] {
    return this.db
      .all(
        `SELECT b.*, (SELECT COUNT(*) FROM media m WHERE m.bucket_id = b.id) AS count
           FROM buckets b
          WHERE b.project_id = ?
          ORDER BY b.display_order ASC`,
        [projectId],
      )
      .map(toBucket);
  }

  byHotkey(projectId: number, hotkey: string): Bucket | null {
    const row = this.db.get(
      `SELECT b.*, 0 AS count FROM buckets b WHERE b.project_id = ? AND b.hotkey = ?`,
      [projectId, hotkey],
    );
    return row ? toBucket(row) : null;
  }

  createDefaults(projectId: number): void {
    DEFAULT_BUCKETS.forEach((bucket, index) => {
      this.db.run(
        `INSERT INTO buckets (project_id, name, kind, hotkey, display_order)
         VALUES (?, ?, ?, ?, ?)`,
        [projectId, bucket.name, bucket.kind, bucket.hotkey, index],
      );
    });
  }
}
